import type { Testimonial } from '../testimonials'

/**
 * Isıl Gürbüz's words, from the closing card of
 * digitopia.co/customers/serenas-part-of-gl-events/ — the three-part capture
 * sent on 2026-08-28 with *"tastamam şekilde, aynısını, tıpkısını tasarla"*.
 *
 * **No picture in the card**, asked for on 2026-08-29 (*"serenas ın customer
 * sayfasının testimonial tasarımında görsel olmasın"*). The slot held the
 * building collage sent as "serenas testimonial photo", because no photograph
 * of Ms Gürbüz was supplied and the file was a cut-out of the shape this card's
 * right-hand side draws. It is dropped rather than replaced: `portrait` is
 * optional and a card without one draws nothing at all — no placeholder, no
 * empty box — which is also what the reference page's own card does. The photo
 * itself stays in the tree and on the story page above, where it is the
 * customer's office picture rather than a stand-in for a face.
 */
export const added: Testimonial = {
  company: 'Serenas (part of GL Events)',
  logo: { name: 'Serenas (part of GL Events)', src: '/logo/serenascard.png' },
  quote: [
    'We were lucky to have Digitopia as our digital transformation partner. It has been a '
    + 'strategic partnership based on independent and objective advice. No other company could '
    + 'have won the minds and hearts of our employees in such a short time and gain their '
    + 'support for digital transformation. We owe the program’s success to this initial buy-in '
    + 'and alignment.',
  ],
  attribution: 'Isil Gurbuz, CEO & Chairwoman',
  story: 'serenas-part-of-gl-events',
}
